<div>
    <div class="gradient-background"></div>
    <div class="login-register-page-block__inner">
        <div class="login-register-page-block__inner__container">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
